export const GlobalMessages = {
  GENERAL_ERROR_BODY: 'Ha ocurrido un error, intente en unos minutos.',
  GENERAL_ERROR_TITLE: 'Alerta',
  NOTE_TITLE: 'Nota',
};

